<template lang="html">
  <div class="modal-wrapper" style="overflow: visible;">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      Dodaj kategoriju
    </div>
    <div v-if="names" class="inputs">
      <div v-for="name in names" :key="name.cat_locale" class="single-input">
        <span>Naziv kategorije - {{ name.cat_locale }}</span>
        <input v-model="name.cat_name" type="text" />
      </div>
      <div class="single-input">
        <div
          v-for="(input, index) in modalData.inputs"
          :key="index"
          class="single-input"
        >
          <dropdown
            v-if="input.type && input.type === 'dropdown'"
            :defaultText="input.label"
            :selected="input.value"
            :list="input.dropdownList"
            style="width: 100%;min-width: 300px;"
            @changeOption="input.value = $event"
          />
        </div>
      </div>
    </div>
    <div class="btn-wrapper">
      <button
        @click="post"
        :disabled="!checkCatNames"
        :class="{ disabled: !checkCatNames }"
        class="btn"
      >
        ok
      </button>
      <div @click="closeModal" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/dropdown.vue";
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
export default {
  name: "addCodebook",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Dropdown
  },
  data() {
    return {
      names: []
    };
  },
  created() {
    for (var i = 0; i < this.$i18n.availableLocales.length; i++) {
      let obj = {
        cat_name: "",
        cat_locale: this.$i18n.availableLocales[i]
      };
      this.names.push(obj);
    }
  },
  mounted() {
    this.populateDropdowns();
  },
  methods: {
    closeModal() {
      eventBus.$emit("closeModal");
    },
    post() {
      console.log(this.modalData.inputs);
      let params = {};
      for (var i = 0; i < this.modalData.inputs.length; i++) {
        let input = this.modalData.inputs[i];
        if (input.type === "dropdown") {
          if (input.value) {
            params[input.key] = input.value.value;
          }
        }
      }
      params.names = this.names;
      api[this.modalData.postApi](params)
        .then(res => {
          console.log(res);
          this.modalData.refresh();
          this.$toast.success("Uspešno", {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error("Greška", {
            duration: 8000
          });
        })
        .finally(() => {
          this.clearInputs();
          this.closeModal();
        });
    },
    clearInputs() {
      let inputs = this.modalData.inputs;
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].value = null;
      }
    },
    populateDropdowns() {
      for (var i = 0; i < this.modalData.inputs.length; i++) {
        if (
          this.modalData.inputs[i].type &&
          this.modalData.inputs[i].type === "dropdown"
        ) {
          let input = this.modalData.inputs[i];
          api[input.dropdownApi]()
            .then(res => {
              input.dropdownList = this.fixDropdownData(
                res.data.data,
                input.dropdownApi
              );
              console.log(input);
            })
            .catch(e => {
              console.log(e);
            });
        }
      }
    },
    fixDropdownData(data, apiUrl) {
      let res = [];
      if (apiUrl === "getCurrencies") {
        for (var i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].cur_name,
            value: data[i].cur_id
          };
          res.push(obj);
        }
      }
      if (apiUrl === "getParentCategories") {
        for (i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].cat_name,
            value: data[i].cat_id
          };
          res.push(obj);
        }
      }
      return res;
    }
  },
  computed: {
    checkCatNames() {
      // Iterate through the array and check if at least one object does not have a cat_name filled
      const isValid = !this.names.some(item => !item.cat_name);
      return isValid;
    },
    getDropdownList() {
      return apiUrl => {
        let data = [];
        api[apiUrl]()
          .then(res => {
            data = res.data.data;
          })
          .catch(e => {
            data = [];
          });
        return data;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
    .disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
